import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=a789dee4&scoped=true&ts=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=ts"

import "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=a789dee4&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a789dee4"]])

export default __exports__